export * from "./dimension-click";

export * from "./dimension-hover";

export * from "./interface";
//# sourceMappingURL=index.js.map
